export const addResourceBundles = (i18n, locale, langFiles) => {
	Object.keys(langFiles).forEach((key) => {
		i18n.addResourceBundle(locale, key, langFiles[key]);
	});
};



// WEBPACK FOOTER //
// ./client/i18n/i18n-util.js